<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="workRecord">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>临时记录
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <downloadBtn
            url="extra/maintenanceDailyRecord/export/list"
            :params="seefrom"
            method="post"
            :needUserId="true"
          ></downloadBtn>
        </div>
        <div class="searchForm1">
          <searchForm
            :items="items"
            :formPlus="form_jsgl"
            ref="searchForm_jsgl"
          >
            <template slot="last">
              <el-form-item label="记录名称:">
                <el-input
                  v-model="seefrom.name"
                  placeholder="请输入记录名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="记录人员:">
                <el-input
                  v-model="seefrom.contactPerson"
                  placeholder="请输入记录人员"
                ></el-input>
              </el-form-item>
              <el-form-item label="记录开始时间:" label-width="115px">
                <el-date-picker
                  v-model="seefrom.startTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择开始时间"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="记录结束时间:" label-width="115px">
                <el-date-picker
                  v-model="seefrom.endTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择结束时间"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <br />
              <el-form-item label="消防系统">
                <el-select
                  :popper-append-to-body="false"
                  v-model="seefrom.fireControlSystemName"
                  placeholder="请选择消防系统"
                  clearable
                  @change="changeSystem"
                >
                  <el-option
                    v-for="item in systemList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="消防设备:">
                <el-select
                  :popper-append-to-body="false"
                  v-model="seefrom.maintenanceContentItemId"
                  placeholder="请选择消防设备"
                  clearable
                  style="width:100%"
                >
                  <el-option
                    v-for="(item, index) in deviceList"
                    :key="index"
                    :label="item.patrolContent"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table
            :data="tableData"
            style="width: 100%"
            class="stripeTable"
            height="500"
            ref="Table"
          >
            <el-table-column
              show-overflow-tooltip
              :label="label"
              :prop="prop"
              :align="align"
              :width="width"
              v-for="{ prop, label, align, width } in config"
              :key="prop.toString()"
            ></el-table-column>
            <el-table-column label="操作" width="170">
              <template slot-scope="scope">
                <el-link
                  icon="iconfont iconcheck"
                  type="text"
                  size="small"
                  @click="check(scope.$index, scope.row)"
                  >详情
                </el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination
              layout="prev, pager, next"
              :page-size="10"
              @current-change="handleCurrentChange"
              :total="nTotal"
              :current-page="currentPage"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-dialog
        :visible.sync="detailDialog"
        class="cust_dialog editDialog"
        title="维修详情"
      >
        <el-form
          :model="detail"
          class="addDetail"
          ref="detail"
          label-suffix="："
          style="margin: 0 40px 0 20px;"
        >
          <el-form-item label="记录名称" prop="name">
            <p>{{ detail.name }}</p>
          </el-form-item>
          <el-form-item label="记录时间" prop="createTime">
            <p>{{ detail.createTime }}</p>
          </el-form-item>
          <el-form-item label="维保单位" prop="deptName">
            <p>{{ detail.deptName }}</p>
          </el-form-item>
          <el-form-item label="记录人员" prop="contactPerson">
            <p>{{ detail.contactPerson }}</p>
          </el-form-item>
          <el-form-item label="消防系统" prop="fireControlSystemName">
            <p>{{ detail.fireControlSystemName }}</p>
          </el-form-item>
          <el-form-item label="消防设备" prop="patrolContent">
            <p>{{ detail.patrolContent }}</p>
          </el-form-item>
          <el-form-item label="检查说明" prop="remark">
            <p>{{ detail.remark }}</p>
          </el-form-item>
          <el-form-item label="附件">
            <template v-if="detail.enclosure">
              <div
                v-for="(bitem, index) in detail.enclosure.split(',')"
                :key="index"
                style=""
              >
                <div>
                  <el-image
                    :src="bitem"
                    :preview-src-list="detail.enclosure.split(',')"
                    style="width: 60px; height: 60px;margin: 0 10px 10px 0;"
                    v-default-img
                  >
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </div>
              </div>
            </template>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
  import { date } from 'utils'
  export default {
    name: 'workRecord',
    data() {
      return {
        form_jsgl: {},
        items: [],
        typeList: [
          {
            label: '巡检故障',
            value: 0
          },
          {
            label: '突发故障',
            value: 1
          }
        ],
        systemList: [],
        deviceList: [],
        statusList: [
          {
            label: '待维修',
            value: 0
          },
          {
            label: '已维修',
            value: 1
          }
        ],
        tabName: 'workRecord',
        seefrom: {},
        tableData: [],
        nTotal: 0,
        currentPage: 1,
        currentSize: 10,
        detailDialog: false,
        detail: {}
      }
    },
    computed: {
      self() {
        return this
      },
      config() {
        return [
          {
            prop: 'createTime',
            label: '巡查时间'
          },
          {
            prop: 'name',
            label: '记录名称'
          },
          {
            prop: 'deptName',
            label: '维保单位'
          },
          {
            prop: 'contactPerson',
            label: '记录人员'
          },
          {
            prop: 'patrolContent',
            label: '消防设备'
          },
          {
            prop: 'fireControlSystemName',
            label: '消防系统'
          }
        ]
      }
    },
    components: {
      normalNav: () => import('public/normalNav'),
      searchForm: () => import('public/searchForm'),
      easyTable: () => import('public/easyTable'),
      downloadBtn: () => import('public/download')
    },
    methods: {
      getSystemList() {
        this.$axiosget('operation/dictionaryType/queryByKey', {
          params: {
            key: 'fireControlSystem'
          }
        }).then(res => {
          if (res.data.status === '10000') {
            this.systemList = res.data.data ? res.data.data.list : []
          }
        })
      },
      changeSystem(e) {
        if (e) {
          console.log(e)
          this.getDeviceList()
        }
      },
      getDeviceList() {
        this.$axiosget('extra/maintenanceContentItem/getListByFireSystem', {
          params: {
            fireControlSystem: this.seefrom.fireControlSystemName
          }
        }).then(res => {
          if (res.data.status == 10000) {
            this.deviceList = res.data.data ? res.data.data : []
          }
        })
      },
      //搜索
      subSeefrom() {
        this.currentPage = 1
        this.getTableData()
      },
      //重置
      reset() {
        this.seefrom = {}
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getTableData()
      },
      // 每页数
      sizeChangeHandle(val) {
        this.currentSize = val
        this.currentPage = 1
        this.getTableData()
      },
      isMaxGtMin() {
        if (!this.seefrom.startTime || !this.seefrom.endTime) return true
        let s = date(this.seefrom.startTime)
        let e = date(this.seefrom.endTime)
        let ns = [s.YY, s.MM, s.DD].join('')
        let ne = [e.YY, e.MM, e.DD].join('')
        return ne > ns ? true : false
      },
      //查询表格数据
      getTableData() {
        if (this.seefrom.startTime && this.seefrom.endTime) {
          if (!this.isMaxGtMin()) {
            this.$notify({
              message: '开始时间需小于结束时间',
              type: 'warning'
            })
            return
          }
        }
        this.$axiosget('extra/maintenanceDailyRecord', {
          params: {
            pageSize: this.currentSize,
            pageNum: this.currentPage,
            ...this.seefrom,
            startTime: this.seefrom.startTime
              ? this.seefrom.startTime
              : undefined,
            endTime: this.seefrom.endTime ? this.seefrom.endTime : undefined
          }
        }).then(res => {
          this.tableData = res.data.data.list
          this.nTotal = res.data.data.total
        })
      },
      changeTab(val) {
        this.activeName = val
      },
      check(index, row) {
        let data = _.cloneDeep(row)
        if (data.enclosure) {
          let fileUrl = data.enclosure.split(',').map(bitem => {
            let fileUrl = process.env.fileUrl
            if (bitem && bitem.includes(fileUrl)) {
              if (process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true') {
                return bitem.replaceAll(
                  fileUrl,
                  process.env.SSL_HOST + '/file/'
                )
              } else {
                return bitem
              }
            } else {
              return bitem
            }
          })
          if (fileUrl.length > 0) {
            data.enclosure = fileUrl.join(',')
          }
        }
        this.detail = data
        this.detailDialog = true
      }
    },
    created() {
      this.getSystemList()
      this.getTableData()
    }
  }
</script>

<style lang="less">
  .w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    z-index: 99;
  }
  .el-input__inner:focus {
    border: 1px solid #3587c7;
  }
</style>

<style lang="less" scoped>
  .cust_dialog /deep/ .el-dialog__body {
    padding-top: 35px;
  }
  .cust_dialog {
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/wbManage/workRecord/index.vue